module.exports = __webpack_public_path__ + "img/wide.bad927e3.jpg";